import type React from 'react';

import { useGetStream } from '@vlabs/api/luna-api/client';
import cn from 'classnames';

import st from './GeneralEventVideoArchive.module.sass';
import { useVideoArchiveTranslation } from './i18n';
import { useVmsFromSourceName } from './useVmsFromSourceName';
import { VideoArchiveWidget } from './VideoArchiveWidget';

interface GeneralEventVideoArchiveProps {
  noDataClassName?: string;
  startTime?: string | null;
  streamId?: string | null;
}

export function GeneralEventVideoArchive({
  noDataClassName = undefined,
  startTime = undefined,
  streamId = undefined,
}: GeneralEventVideoArchiveProps): React.JSX.Element {
  const { t } = useVideoArchiveTranslation();
  const { data: stream } = useGetStream(streamId ?? '', undefined, {
    query: {
      enabled: !!streamId,
    },
  });

  const streamName = stream?.name ?? stream?.stream_id;
  const { vmsSource } = useVmsFromSourceName(streamName);

  if (!vmsSource) {
    return (
      <div className={cn(st.NoMatchDummy, noDataClassName)}>{t('no_data')}</div>
    );
  }

  return (
    <div className={st.Root}>
      <div className="Subtitle-2">
        {t('title')}
      </div>
      <div className={st.MainSection}>
        <div className={st.VideoArchiveWidget__Root}>
          <VideoArchiveWidget
            startTime={startTime}
            vmsSource={vmsSource}
          />
        </div>
      </div>
    </div>
  );
}
